import { useAuth } from '../../state/useAuth';
import AdminDashboard from './Dashboard';
import CommercialWelcome from './CommercialWelcome';

export default function AdminIndex(){
  const { role } = useAuth();
  if(role === 'admin') return <AdminDashboard/>;
  if(role === 'commercial') return <CommercialWelcome/>;
  return null;
}
